import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { SnackbarProvider } from 'notistack';

// import { store } from 'store';
import Routes from 'Routes';
import awsconfig from 'aws-exports';
import { StoreProvider } from 'easy-peasy';
import store from './store';
import { TourProvider } from '@reactour/tour';
import steps from './tours/editor';
import 'index.scss';
import "react-grid-layout/css/styles.css";
import { Authenticator } from '@aws-amplify/ui-react';

Amplify.configure(awsconfig);

function App() {
  return (
    <Authenticator.Provider>
      <SnackbarProvider
        maxSnack={5}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <StoreProvider store={store}>
          <TourProvider steps={steps}>
            <Router>  
              <Routes />
            </Router>
          </TourProvider>
        </StoreProvider>
      </SnackbarProvider>
    </Authenticator.Provider>
  );
}

export default App;
